// extracted by mini-css-extract-plugin
export default {"emptyResults":"NoTimTalents_emptyResults__G-5Oh","paginationContainer":"NoTimTalents_paginationContainer__LVnwL"};